import { styled, Chip, chipClasses } from '@mui/material';

import { AccessFeatureNexPlanChipBaseProps } from './types';

export const AccessFeatureNextPlanChipRoot = styled(Chip, {
  shouldForwardProp: (prop) => prop !== 'gutterLeft' && prop !== 'gutterRight',
})<AccessFeatureNexPlanChipBaseProps>(({ theme, gutterLeft, gutterRight }) => ({
  fontSize: theme.typography.pxToRem(9),
  height: 16,
  textTransform: 'uppercase',
  fontWeight: theme.typography.fontWeightBold,
  backgroundColor: theme.palette.common.white,

  ...(gutterLeft && { marginLeft: theme.spacing(1) }),
  ...(gutterRight && { marginRight: theme.spacing(1) }),

  [`&.${chipClasses.clickable}:hover`]: {
    backgroundColor: theme.palette.common.white,
  },

  [`& .${chipClasses.label}`]: {
    padding: theme.spacing(0, 0.5),
  },
}));
